import type { QuestionWithSlide } from '@mentimeter/voting-schema/api-types-overrides';

export const getIsInteractiveSlide = (question: QuestionWithSlide) => {
  return !['slide', 'qfa'].includes(question.type);
};
